import api from "./api";
import {iniciarRequisicao} from "../helpers";

class DashboardAPI {

  async getDadosGraficoGrupo(headers, params) {
    const response = await api.get("/dash_grafico_grupos", { params, headers });
    return response;
  }

  async getTotaisGrupo(id_grupo, params = {}) {
    const headers = iniciarRequisicao();
    const response = await api.get(`/dashboard/grupos/${id_grupo}`, { params, headers });
    return response;
  }

  async getFornecedoresLista(headers, params) {
    const response = await api.get('/listafornecedores_grupo', { params, headers });
    return response;
  }

  async getFornecedoresTabelaGrupo(headers, params) {
    const response = await api.get('/dash_fornecedores_grupo', { params, headers });
    return response;
  }

  async getListaFornecedoresComptadorTabelaGrupo(headers, params) {
    const response = await api.get('/dash_fornecedores_comprador_grupo', { params, headers });
    return response;
  }

  async getCompradoresTabelaGrupo(headers, params) {
    const response = await api.get('/dash_compradores_grupo', { params, headers });
    return response;
  }

  async getCategoriasTabelaGrupo(headers, params) {
    const response = await api.get('/dash_categorias_grupo', { params, headers });
    return response;
  }

  // async getProdutosTabelaGrupo(headers, params) {
  //   const response = await api.get('/dash_produtos_grupo', { params, headers });
  //   return response;
  // }

  async getPedidosTabelaGrupo(headers, params) {
    const response = await api.get('/dash_pedidos_grupo', { params, headers });
    return response;
  }

  async getListaSegmentosComprador(headers, params) {
    const response = await api.get('/dash_categorias_comprador_grupo', { params, headers });
    return response;
  }

  async getValidateUser(headers) {
    const response = await api.get("/me", { headers });
    return response;
  }

  async getEficienciaComprador(headers, params) {
    const response = await api.get("/get_eficiencia_comprador", { params, headers });
    return response;
  }

  async getProdutosStatusPercepcao(headers, params) {
    return await api.get("/get_produtos_status_percepcao", { params, headers });
  }

  async getProdutosGrupoPaginados(params) {
    const headers = iniciarRequisicao();
    return await api.get(`/dash/produtos/grupo`, { params, headers });
  }

  async getUltimaDataIntegracao(headers) {
    return await api.get("/get_data_ultima_integracao", {headers})
  }
}

export default new DashboardAPI();
